import React, {memo} from 'react';

import {translate} from '@mapsight/ui/src/js/helpers/i18n';
import FeatureList from '@mapsight/ui/src/js/components/feature-list';

import {useNavPos} from '../../../hooks';
import Link from '../link';

import ListItem from './list-item';

// TODO STADE irgendwie zur Liste scrollen ... oder vielleicht doch kein AUfmacherbild bei der Liste??
// mit id und #l funktioniert es nicht mit der js-history

export default memo(
	function List(props) {
		const navPos = useNavPos();

		return (
			<div className={`stade-text stade-list ${navPos.listMorePoi ? 'stade-list--more' : ''} `}>
				<FeatureList itemAs={ListItem} {...props} />
				{navPos.haveMorePoi &&
				<p>
					<Link
						to={`/${navPos.list ? 'poi-' : ''}liste`}>{translate(navPos.list ? 'stade.list.toMore' : 'stade.list.toList')}</Link>
				</p>
				}
			</div>
		);
	}
);
